export default __webpack_public_path__ + "74d6a15647e40558dd80e8dda569976e.svg";